import 'remixicon/fonts/remixicon.css';
import { Task } from '../../store/viewmodels/TaskViewModel';
import { Itemset } from '../../store/viewmodels/ItemsetViewModel';
import { AnswerSetResult } from '../../store/viewmodels/AnswerSetViewModel';
import { getLogos } from '../../utils/TaskContentServices';

export function getItemsetLogos(itemset: Itemset): JSX.Element[] {
    let logos: JSX.Element[] = [];
    if (itemset.logos) {
        logos = itemset.logos.map(logo => <img key={"itemset_logo_" + logo.id} className=" mx-1 w-5 h-5 2xl:w-6 2xl:h-6" src={getLogos(logo.logo)} alt={logo.name} />)
    }

    return logos;
}

export function getTaskLogos(task: Task): JSX.Element {
    const vikkeAddress = "https://vikke.nmi.fi/wp-content/uploads/2021/05/Vikke_symboli_800px-768x614.png";
    const taskThemeLogo = task.logo?.logo ?
        <img className="mr-2 w-20 h-auto" src={getLogos(task.logo.logo)} alt={task.theme} /> :
        <img className="mr-2 w-20 h-auto" src={vikkeAddress} alt={"Vikke"} />;

    return taskThemeLogo;
}

export function getItemsetStar(task: Task, itemset: Itemset, answerSets: AnswerSetResult[]): JSX.Element {
    const itemsetDone = isItemsetDone(answerSets, itemset);
    const itemsetStar: JSX.Element = itemsetDone ? <span className="ri-star-fill mr-2 text-yellow-500 "></span> : <span className="ri-star-line mr-2 text-yellow-500 "></span>;
    return itemsetStar;
}

export function isItemsetDone(answersets: AnswerSetResult[], itemset: Itemset): boolean {
    let answersItemsetIds = answersets.map(a => a.itemset.id);

    if (answersItemsetIds.includes(itemset.id)) return true;
    return false;
}

export function getTaskStars(task: Task, tasksAnswers: AnswerSetResult[], tasksItemsets: Itemset[]): JSX.Element {
    const allDone: boolean = isAllDone(tasksAnswers, tasksItemsets);
    const allStars = task.itemsets.length;
    const starCount = allDone ? allStars : itemsetsDone(tasksAnswers, tasksItemsets);
    const emptyStarsCount: number = allStars - starCount;

    let doneStars: JSX.Element[] = [];
    let stars: JSX.Element[] = [];
    let emptyStars: JSX.Element[] = [];

    for (let s: number = 0; s < allStars; s++) {
        stars.push(
            <span className="ri-star-fill" key={task.name + task.id + "_star_" + s}></span>
        )
    }

    for (let s: number = 0; s < starCount; s++) {
        doneStars.push(
            <span className="ri-star-fill" key={task.name + task.id + "_donestar_" + s}></span>
        )
    }

    for (let s: number = 0; s < emptyStarsCount; s++) {
        emptyStars.push(
            <span className="ri-star-line" key={task.name + task.id + "_emptystar_" + s}></span>
        )
    }

    const starElement = stars.length > 0 ?
        (<div className="flex ml-4">
            <div className="text-yellow-500 text-3xl m-auto">
                {doneStars}
                {emptyStars}
            </div>
            <div className="text-yellow-500 text-3xl m-auto">/</div>
            <div className="text-yellow-500 text-3xl m-auto">{stars}</div>
        </div>)
        : <></>;

    return starElement;
}

export function getBadges(count: number, itemsetId: number) {
    let awards = [];

    for (let i: number = 0; i < count; i++) {
        awards.push(<span className="ri-award-fill text-red-600" key={"badge_" + i + "_" + itemsetId}></span>)
    }

    return (
        <div className="text-6xl mb-2 mt-4 mx-auto text-center flex flex-wrap justify-center">
            {awards}
        </div>
    );
}

export function getTrophys(min: number, itemsetId: number): JSX.Element {
    let hours = Math.floor(min / 60);
    let trophys = [];

    for (let i: number = 0; i < hours; i++) {
        trophys.push(<span className="ri-trophy-fill text-yellow-600 px-1" key={"trophy_" + i + "_" + itemsetId}></span>);
    }

    return (
        <div className="text-6xl mb-2 mt-4 mx-auto text-center flex flex-wrap justify-center">
            {trophys}
        </div>
    );
}

function itemsetsDone(answerSets: AnswerSetResult[], itemsets: Itemset[]): number {
    let count: number = 0;
    let answersItemsetIds = answerSets.map(a => a.itemset.id);

    for (let i: number = 0; i < itemsets.length; i++) {
        if (answersItemsetIds.includes(itemsets[i].id)) {
            count++;
        }
    }
    return count;
}

function isAllDone(answersets: AnswerSetResult[], itemsets: Itemset[]): boolean {
    let answersItemsetIds = answersets.map(a => a.itemset.id);
    for (let i: number = 0; i < itemsets.length; i++) {
        if (!answersItemsetIds.includes(itemsets[i].id)) {
            return false;
        }
    }
    return true;
}